import { Injectable } from '@angular/core';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class SlackService {
  // private webhookUrl = 'https://a188d97ffed3.ngrok-free.app/log';
  private webhookUrl = 'https://nodelogger.axonwireless.co.za/log';

  constructor() { }

  sendMessage(message: any): Promise<void> {
    try {
      return axios.post(this.webhookUrl, {
        text: message
      });
    } catch (error) {
    }
  }

  // sendMessage(message: any) { }
}